import {css, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {display, m} from "@pg-design/helpers-css";
import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IMapOfferSidebar} from "../offer/map/types/MapOfferSidebar";
import {IOfferDetail} from "../offer/types/IOfferDetail";
import {OfferType} from "../offer/types/OfferType";
import {propertiesSortOptions} from "./PropertyListTable";

interface IProps {
    offer: IOfferDetail | IMapOfferSidebar;
    onSortChange: (value: string) => void;
    sort: string | null;
    showPriceColumn: boolean;
    hideCell?: {
        propertyPlan?: boolean;
        propertyNumber?: boolean;
        propertyRooms?: boolean;
        propertyArea?: boolean;
        plotArea?: boolean;
        propertyFloor?: boolean;
        propertyPrice?: boolean;
    };
}

type TSortDirection = "asc" | "desc";

export const PropertyListTableHeader = (props: IProps) => {
    const {offer, onSortChange, sort, showPriceColumn, hideCell} = props;

    const propertyListHeaders = () => [
        // number
        propertiesSortOptions.NUMBER,
        // rooms - conditional
        ...(offer.type === OfferType.HOUSE || offer.type === OfferType.FLAT ? [propertiesSortOptions.ROOMS] : []),
        // area
        propertiesSortOptions.AREA,
        // floor OR plot_area
        offer.type === OfferType.HOUSE ? propertiesSortOptions.PLOT_AREA : propertiesSortOptions.FLOOR,
        // price
        ...(showPriceColumn ? [propertiesSortOptions.PRICE] : [])
    ];

    const onHeaderClick = (value: string) => {
        const finalValue = sort === value ? `-${value}` : value;
        onSortChange(finalValue);
    };

    const getHideValue = (type: string) => {
        switch (type) {
            case "number":
                return hideCell?.propertyNumber;
            case "rooms":
                return hideCell?.propertyRooms;
            case "area":
                return hideCell?.propertyArea;
            case "floor":
                return hideCell?.propertyFloor;
            case "price":
                return hideCell?.propertyPrice;
            default:
                return false;
        }
    };

    const theme = useTheme();

    return (
        <tr css={rowStyle}>
            <HeaderCell showOnMobile hideCell={hideCell?.propertyPlan}>
                <Text align="left" variant="body_copy_1" as="span" css={[styleOverrides, display("block")]}>
                    Rzut
                </Text>
            </HeaderCell>

            {propertyListHeaders().map((header) => {
                const isActive = sort ? header.value === sort || `-${header.value}` === sort : false;
                const sortDirection: TSortDirection = isActive && sort && sort.includes("-") ? "desc" : "asc";

                return (
                    <HeaderCell
                        showOnMobile={header.showOnMobile}
                        hideCell={getHideValue(header.value)}
                        sortable
                        sortDirection={sortDirection}
                        isActive={isActive}
                        key={header.value}
                        onClick={() => onHeaderClick(header.value)}
                    >
                        <Text variant="body_copy_1" as="span" css={styleOverrides}>
                            {header.shortName}
                        </Text>

                        <IconWrapper sortDirection={sortDirection}>
                            <ChevronDownIcon size="1.3" fill={theme.colors.gray[700]} />
                        </IconWrapper>
                    </HeaderCell>
                );
            })}
        </tr>
    );
};

interface IHeaderCell {
    isActive?: boolean;
    sortDirection?: TSortDirection;
    sortable?: boolean;
    showOnMobile?: boolean;
    hideCell?: boolean;
}

const HeaderCell = styled.th<IHeaderCell>`
    padding: 0 0.5rem;
    height: 54px;
    vertical-align: middle;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
    text-align: center;
    white-space: nowrap;
    border: 0;
    font-weight: normal;

    &:first-of-type {
        padding: 1rem 1.4rem 1rem 1.2rem;
        text-align: left;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
        height: 64px;

        &:first-of-type {
            padding: 1rem 2.8rem;
        }
    }

    ${(props) =>
        props.sortable &&
        css`
            cursor: pointer;
        `}

    ${(props) => css`
        display: ${props.showOnMobile && !props.hideCell ? "table-cell" : "none"};
        @media (min-width: ${props.theme.breakpoints.sm}) {
            display: ${props.hideCell ? "none" : "table-cell"};
        }
    `}
`;

interface IIconWrapper {
    sortDirection: TSortDirection;
}

const IconWrapper = styled.span<IIconWrapper>`
    ${m(0, 0, 0, 0.5)};

    @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
        ${m(0, 0, 0, 1)};
    }
    > svg {
        transform: ${(props) => (props.sortDirection === "asc" ? `rotate(180deg) scale(1.3)` : "")};
    }
    ${(props) =>
        props.sortDirection === "asc"
            ? css`
                  & > svg {
                      transform: rotate(180deg) scale(1.5);
                  }
              `
            : ""};
`;

const rowStyle = css`
    width: 100%;
`;

const styleOverrides = css`
    font-size: 1.35rem;
`;
import {css, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {display, m} from "@pg-design/helpers-css";
import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IMapOfferSidebar} from "../offer/map/types/MapOfferSidebar";
import {IOfferDetail} from "../offer/types/IOfferDetail";
import {OfferType} from "../offer/types/OfferType";
import {propertiesSortOptions} from "./PropertyListTable";

interface IProps {
    offer: IOfferDetail | IMapOfferSidebar;
    onSortChange: (value: string) => void;
    sort: string | null;
    showPriceColumn: boolean;
    hideCell?: {
        propertyPlan?: boolean;
        propertyNumber?: boolean;
        propertyRooms?: boolean;
        propertyArea?: boolean;
        plotArea?: boolean;
        propertyFloor?: boolean;
        propertyPrice?: boolean;
    };
}

type TSortDirection = "asc" | "desc";

export const PropertyListTableHeader = (props: IProps) => {
    const {offer, onSortChange, sort, showPriceColumn, hideCell} = props;

    const propertyListHeaders = () => [
        // number
        propertiesSortOptions.NUMBER,
        // rooms - conditional
        ...(offer.type === OfferType.HOUSE || offer.type === OfferType.FLAT ? [propertiesSortOptions.ROOMS] : []),
        // area
        propertiesSortOptions.AREA,
        // floor OR plot_area
        offer.type === OfferType.HOUSE ? propertiesSortOptions.PLOT_AREA : propertiesSortOptions.FLOOR,
        // price
        ...(showPriceColumn ? [propertiesSortOptions.PRICE] : [])
    ];

    const onHeaderClick = (value: string) => {
        const finalValue = sort === value ? `-${value}` : value;
        onSortChange(finalValue);
    };

    const getHideValue = (type: string) => {
        switch (type) {
            case "number":
                return hideCell?.propertyNumber;
            case "rooms":
                return hideCell?.propertyRooms;
            case "area":
                return hideCell?.propertyArea;
            case "floor":
                return hideCell?.propertyFloor;
            case "price":
                return hideCell?.propertyPrice;
            default:
                return false;
        }
    };

    const theme = useTheme();

    return (
        <tr css={rowStyle}>
            <HeaderCell showOnMobile hideCell={hideCell?.propertyPlan}>
                <Text align="left" variant="body_copy_1" as="span" css={[styleOverrides, display("block")]}>
                    Rzut
                </Text>
            </HeaderCell>

            {propertyListHeaders().map((header) => {
                const isActive = sort ? header.value === sort || `-${header.value}` === sort : false;
                const sortDirection: TSortDirection = isActive && sort && sort.includes("-") ? "desc" : "asc";

                return (
                    <HeaderCell
                        showOnMobile={header.showOnMobile}
                        hideCell={getHideValue(header.value)}
                        sortable
                        sortDirection={sortDirection}
                        isActive={isActive}
                        key={header.value}
                        onClick={() => onHeaderClick(header.value)}
                    >
                        <Text variant="body_copy_1" as="span" css={styleOverrides}>
                            {header.shortName}
                        </Text>

                        <IconWrapper sortDirection={sortDirection}>
                            <ChevronDownIcon size="1.3" fill={theme.colors.gray[700]} />
                        </IconWrapper>
                    </HeaderCell>
                );
            })}
        </tr>
    );
};

interface IHeaderCell {
    isActive?: boolean;
    sortDirection?: TSortDirection;
    sortable?: boolean;
    showOnMobile?: boolean;
    hideCell?: boolean;
}

const HeaderCell = styled.th<IHeaderCell>`
    padding: 0 0.5rem;
    height: 54px;
    vertical-align: middle;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
    text-align: center;
    white-space: nowrap;
    border: 0;
    font-weight: normal;

    &:first-of-type {
        padding: 1rem 1.4rem 1rem 1.2rem;
        text-align: left;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
        height: 64px;

        &:first-of-type {
            padding: 1rem 2.8rem;
        }
    }

    ${(props) =>
        props.sortable &&
        css`
            cursor: pointer;
        `}

    ${(props) => css`
        display: ${props.showOnMobile && !props.hideCell ? "table-cell" : "none"};
        @media (min-width: ${props.theme.breakpoints.sm}) {
            display: ${props.hideCell ? "none" : "table-cell"};
        }
    `}
`;

interface IIconWrapper {
    sortDirection: TSortDirection;
}

const IconWrapper = styled.span<IIconWrapper>`
    ${m(0, 0, 0, 0.5)};

    @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
        ${m(0, 0, 0, 1)};
    }
    > svg {
        transform: ${(props) => (props.sortDirection === "asc" ? `rotate(180deg) scale(1.3)` : "")};
    }
    ${(props) =>
        props.sortDirection === "asc"
            ? css`
                  & > svg {
                      transform: rotate(180deg) scale(1.5);
                  }
              `
            : ""};
`;

const rowStyle = css`
    width: 100%;
`;

const styleOverrides = css`
    font-size: 1.35rem;
`;
